import Container from "layouts/container/Container";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DeskTopTrackOrderDetail from "./trackorder/DeskTopTrackOrderDetail";
import MobileTrackOrderDetail from "./trackorder/MobileTrackOrderDetail";
import EmptyPage from "routes/empty/EmptyPage";

function TrackOrderDetail(props) {
    const { isMobile } = useContext(BrowserDetectContext);
    const { userName, userInfo } = useContext(AuthContext);
    const location = useLocation();

    return (
        <Container>
            <Container maxWidth={1200} minWidth={!isMobile && 1200}>
                {
                    isMobile
                        ?
                        <MobileTrackOrderDetail data={props} />
                        :
                        // <DeskTopTrackOrderDetail data={props} />
                        <EmptyPage />
                }
            </Container>

        </Container>
    );
}

export default TrackOrderDetail;